<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">Unzip the .zip file</h4>
  <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onCancel()" title="Close"></i>
</div>
<div class="modal-body text-grey">
  <input type="checkbox" name="" [(ngModel)]="toZipCheck" id="toZipCheck"><label class="ms-1" for="toZipCheck">{{ dialogMessage }}</label>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Cancel</button>
  <button
    type="button" class="btn btn-primary"
    cdkFocusInitial
    (click)="onSubmit()"
  >
    Proceed
  </button>
</div>